import { Campaign } from '../types';

export const CAMPAIGN_TYPE_OPTIONS: { value: Campaign['type']; label: string }[] = [
  { value: 'BOTH', label: 'Both (MP4 and 360)' },
  { value: 'PHOTO', label: 'Photo (MP4 only)' },
  { value: 'PANORAMA', label: 'Panorama (360 only)' },
];
